<!-- <div>
    <mat-button-toggle-group #colorToggle="matButtonToggleGroup" value="primary" aria-label="Change color">
        <mat-button-toggle value="primary"> Primary </mat-button-toggle>
        <mat-button-toggle value="accent"> Accent </mat-button-toggle>
    </mat-button-toggle-group>
    <span class="example-button-toggle-label"> Color </span>
</div>

<div>
    <mat-button-toggle-group #backgroundColorToggle="matButtonToggleGroup" value="primary" aria-label="Change color">
        <mat-button-toggle value="primary"> Primary </mat-button-toggle>
        <mat-button-toggle value="accent"> Accent </mat-button-toggle>
    </mat-button-toggle-group>
    <span class="example-button-toggle-label"> Background Color </span>
</div> -->

<h2 class="comp-title" style="margin-bottom: 25px;">Tab</h2>

<mat-tab-group animationDuration="0ms" [disableRipple]="true" class="max-tab" >
    <mat-tab label="שירות לקוחות"> תוכן לדוגמא 1</mat-tab>
    <mat-tab label="אישורים וחסימות">תוכן לדוגמא 2</mat-tab>
    <mat-tab label="רישום והתחברות"> תוכן לדוגמא 3 </mat-tab>
    <mat-tab label="גבייה"> תוכן לדוגמא 4 </mat-tab>
    <mat-tab label="הצטרפות">תוכן לדוגמא 5 </mat-tab>
</mat-tab-group>